import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { CommentAgentOpenChatMenuItemProps } from '../src/components/CommentAgentOpenChatMenuItem.tsx';

export const CommentAgentOpenChatMenuItemAsync: LoadableType<CommentAgentOpenChatMenuItemProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-CommentAgentOpenChatMenuItem" */ '../src/components/CommentAgentOpenChatMenuItem.tsx'
				)
			).CommentAgentOpenChatMenuItem,
	});
